import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ProjectProductModel } from '../../../../../model/builk/coupon/project-product.model';
import { CouponService } from '../../../../../service/api/builk/coupon.service';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.scss']
})
export class AccessibilityComponent {
  @ViewChild("template") template: TemplateRef<any>;

  modalRef: BsModalRef;

  @Output() isSaved = new EventEmitter();
  @Output() okEvent = new EventEmitter();

  // array
  productList: Array<ProjectProductModel> = [];
  preProductList: Array<ProjectProductModel> = [];

  // boolean
  isLoading: boolean = false;
  isCreating: boolean = false;

  // number
  currentProductId: number = 0;
  currentProductIndex: number;

  constructor(
    private modalService: BsModalService,
    private couponService: CouponService,
    private localStorageService: LocalStorageService
  ) { }

  openModal(): void {
    this.currentProductId = 0;
    this.getProduct();
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-lg"
    });
  }

  close(): void {
    this.modalRef.hide();
  }

  getProduct(): void {
    this.isLoading = true;
    this.couponService.getProduct().subscribe(res => {
      if (res !== null && res.length > 0) {
        this.productList = res;
      }
      this.isLoading = false;
    }, err => {
      console.log(err.message);
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
    });
  }

  addProduct(): void {
    this.preProductList.push({
      createUserId: this.localStorageService.get("userSurrKey"),
      projProdName: "",
      projProdSurrKey: 0
    });
  }

  onSelectProduct(id: number): void {
    if (id === this.currentProductId) {
      this.currentProductId = 0;
    } else {
      this.currentProductId = id;
    }
  }

  onRemove(index: number): void {
    this.preProductList.splice(index, 1);
    this.preProductList = this.preProductList.map(val => val);
  }

  onSubmitProduct(index: number): void {
    this.currentProductIndex = index;
    this.isCreating = true;
    let model = this.preProductList[index];
    this.couponService.createProduct([model]).subscribe(res => {
      if (res !== null && res === true) {
        this.onRemove(index);
        this.getProduct();
      }
      this.isCreating = false;
    }, err => {
      console.log(err.message);
      this.isCreating = false;
    }, () => {
      this.isCreating = false;
    });
  }

  save(): void {
    //save
  }
}
